module.exports = __webpack_public_path__ + "img/VeryUnhappy.cda99a30.svg";